export { default } from './WithMaxWidth';
export { InjectedWithMaxWidthProps } from './WithMaxWidth.types';
